import { matchRoutes, type RouteObject } from "react-router-dom";

import type { RouteContext } from "./posthog";

/** Join a matched branch's paths into one pattern. Child paths here are mostly absolute. */
function patternOf(paths: (string | undefined)[]): string {
  let pattern = "";
  for (const path of paths) {
    if (!path) continue;
    pattern = path.startsWith("/")
      ? path
      : `${pattern.replace(/\/$/, "")}/${path}`;
  }
  return pattern || "/";
}

function sectionOf(pattern: string): string {
  const [first, second] = pattern.split("/").filter(Boolean);
  if (first === "app") {
    if (!second) return "dashboard";
    return second === "*" ? "not_found" : second;
  }
  if (first === "app-reports") return "reports";
  if (first === "auth" || first === "signup") return first;
  return "public";
}

/**
 * Map a URL path to its route pattern and product area, e.g.
 * `/app/jobs/8f1c` → `{ route: "/app/jobs/:id", section: "jobs" }`.
 */
export function resolveRouteContext(
  routes: RouteObject[],
  pathname: string
): RouteContext | undefined {
  const matches = matchRoutes(routes, pathname);
  if (!matches?.length) return undefined;
  const route = patternOf(matches.map((match) => match.route.path));
  return { route, section: sectionOf(route) };
}
